export default __webpack_public_path__ + "img/14ee70a336c1ebbb0ddfe70b414dda1b.png";